import { render, staticRenderFns } from "./live-matches.vue?vue&type=template&id=240f5330&scoped=true&"
import script from "./live-matches.vue?vue&type=script&lang=js&"
export * from "./live-matches.vue?vue&type=script&lang=js&"
import style0 from "./live-matches.vue?vue&type=style&index=0&id=240f5330&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f5330",
  null
  
)

export default component.exports